import { useState } from "react";

/** Open/pending state for a confirm dialog. The parent action surfaces its own errors; we just close on success. */
export function useConfirmedAction(run: () => Promise<unknown>) {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);

  async function confirm() {
    setPending(true);
    try {
      await run();
      setOpen(false);
    } catch {
      // Parent shows the error; keep the dialog open so the person can retry or cancel.
    } finally {
      setPending(false);
    }
  }

  return { open, setOpen, pending, confirm };
}
